/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_1_AInputs */

const en_mk_faq_1_a = /** @type {(inputs: Mk_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Agents run on KerjaBareng's servers with models we already provide — no daemon, CLI, or model credentials for you to set up.`)
};

const id_mk_faq_1_a = /** @type {(inputs: Mk_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak. Agen berjalan di server KerjaBareng dengan model yang sudah disediakan — tidak ada daemon, CLI, atau kredensial model yang harus kamu pasang sendiri.`)
};

/**
* | output |
* | --- |
* | "No. Agents run on KerjaBareng's servers with models we already provide — no daemon, CLI, or model credentials for you to set up." |
*
* @param {Mk_Faq_1_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_1_a = /** @type {((inputs?: Mk_Faq_1_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_1_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_1_a(inputs)
	return en_mk_faq_1_a(inputs)
});